export default {
    POLLING: 'POLLING',
    UPDATE_NEEDED: 'UPDATE_NEEDED',
    NO_UPDATE_NEEDED: 'NO_UPDATE_NEEDED',
};
